import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import {setPhoneNumberForCallBack , goToPage} from '../../GenericWizardBlockSlice';
import {doCallBack} from '../../GenericWizardBlockThunk';
import CallBack from '../../../../Shared/CallBack/CallBack';

const CallBackPage = (props) => {

  return (
      <div className='call-back-page'>
        <CallBack subjectCode={props.subjectCode} contactNumber={props.contactNumber} memoCode={props.memoCode} memoText={props.memoText} />
      </div>
  );
};

const mapStateToProps = (state) => {
  return {
    contactNumber : state.authentication?.loginData?.userDetails?.contactNumber,
    subjectCode: state.genericWizardBlock.epiBlockData?.subjectCode,
    memoCode: state.genericWizardBlock.epiBlockData.memoCode,
    memoText: state.genericWizardBlock.epiBlockData.memoTextCallBack,
  };
};

const mapDispatchToProps = { setPhoneNumberForCallBack , goToPage, doCallBack };

export default connect(mapStateToProps, mapDispatchToProps)(CallBackPage);
